<template>
  <div :class="{'pt-item':true, 'pt-item-current': current, 'pt-item-completed': completed, 'pt-item-cancelled': cancelled, 'pt-item-paused': paused}">
    <div class="pt-item-head-spacer">
      <div class="pt-left">
        <div class="pt-line"> </div>
      </div>
      <div class="pt-right"> </div>
    </div>
    <div class="pt-item-header">
      <div class="pt-left">
        <div class="pt-circle">
          <i :class="[completed || cancelled ? 'fas' : 'fal', displayIcon]"></i>
        </div>
      </div>
      <div class="pt-header-info">
        <div class="pt-header-title">{{title}}</div>
        <small v-if="timestamp && (completed || cancelled)">{{timestamp | formatDateTime}}</small>
        <small v-if="note && !completed && !current && !cancelled">{{note}}</small>
      </div>
    </div>
    <div class="pt-item-content">
      <div class="pt-left">
        <div class="pt-line"> </div>
      </div>
      <div class="pt-right pt-content-area">
        <slot name="all" />
        <slot name="waiting" v-if="!completed && !current" />
        <slot name="current" v-if="current" />
        <slot name="completed" v-if="completed" />
        <slot name="cancelled" v-if="cancelled" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
$left-padding-size: 30px;
$pt-icon-size: 40px;
$pt-line-width: 5px;
$pt-line-left: 18px;    // icon-size / 2 - line-width / 2
$pending-color: #BCC2C9;
$completed-color: #4EB93C;
$cancelled-color: #ed6666;
$current-color: #FF9639;
$current-paused-color: #FF9639;
$current-paused-opacity: 0.6;
$content-width-fraction: 1.0;


.pt-item-head-spacer {
  display: none;
  padding-left: $left-padding-size;
}
.pt-item:not(:first-child) .pt-item-head-spacer {
  display: flex;
}
.pt-item-head-spacer .pt-right {
  height: 16px;
}
.pt-item-current {
  background-color: #F2F2F0;
  border-radius: $layout-border-radius;
}
.pt-item-header {
  display: flex;
  padding-left: $left-padding-size;
}
.pt-item-content {
  display: flex;
  padding-left: $left-padding-size;
}
.pt-item:last-child .pt-item-content .pt-left .pt-line {
  display: none;
}
.pt-left {
  flex-basis: 64px;
}
.pt-right {
  flex-grow: 1.0;
}
.pt-content-area {
  flex-grow: $content-width-fraction;
  padding-top: 6px;
  padding-bottom: 1.75rem;
  font-size: 0.7rem;
  color: #9aa1a5;
}
.pt-content-area p {
  margin-bottom: 0.33rem;
}
.pt-content-area h4 {
  color: #676a6c;
}
.pt-content-area h5 {
  color: #676a6c;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.65rem;
  margin: 0 0 4px 0;
}
.pt-item-current .pt-content-area {
  margin-top: -10px;
  padding-top: 0px;
}
.pt-line {
  width: $pt-line-width;
  height: 100%;
  margin-left: $pt-line-left;
  background-color: $pending-color;
}
.pt-item-completed .pt-line {
  background-color: $completed-color;
}
.pt-item-cancelled .pt-line {
  background-color: $cancelled-color;
}
.pt-item-current .pt-line {
  background-color: $current-color;
}
.pt-item-current.pt-item-paused .pt-line {
  background-color: $current-paused-color;
  opacity: $current-paused-opacity;
}
.pt-header-info {
  flex-grow: $content-width-fraction;
  line-height: 1.0rem;
}
.pt-item-completed .pt-header-info,
.pt-item-cancelled .pt-header-info {
  border-bottom: 1px solid #efefef;
}
.pt-header-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: inherit;
}
.pt-item-completed .pt-header-title {
  color: $completed-color;
}
.pt-item-cancelled .pt-header-title {
  color: $cancelled-color;
}
.pt-item-current .pt-header-title {
  color: $current-color;
}
.pt-item-current.pt-item-paused .pt-header-title {
  color: $current-paused-color;
  opacity: $current-paused-opacity;
}
.pt-header-info small {
  font-size: 0.65rem;
  color: #a0a0a0;
}
.pt-circle {
  width: $pt-icon-size;
  height: $pt-icon-size;
  border-radius: 50%;
  background-color: $pending-color;
  color: #ffffff;
  line-height: $pt-icon-size;
  vertical-align: middle;
  text-align: center
}
.pt-circle i {
  line-height: $pt-icon-size;
  font-size: 1.25rem;
}
.pt-item-completed .pt-circle {
  background-color: $completed-color;
}
.pt-item-cancelled .pt-circle {
  background-color: $cancelled-color;
}
.pt-item-current .pt-circle {
  background-color: $current-color;
}
.pt-item-current.pt-item-paused .pt-circle {
  background-color: $current-paused-color;
  opacity: $current-paused-opacity;
}

.pt-item-panel {
  border: 1px solid #e7eaec;
  background-color: #f7f7f7;
  box-shadow: none;
  margin-top: 4px;
  margin-bottom: 2px;
  padding: 4px 6px;
}

</style>

<script>
export default {
  name: 'ProgressTrackerItem',
  props: {
    title: String,
    timestamp: String,
    note: String,
    icon: String,
    completed: Boolean,
    cancelled: Boolean,
    current: Boolean,
    paused: Boolean
  },
  computed: {
    displayIcon() {
      if(this.completed)
        return 'fa-check'
      if(this.cancelled)
        return 'fa-times'
      if(this.paused && this.current)
        return 'fa-pause'
      return this.icon
    }    
  }
}
</script>